module.exports = __webpack_public_path__ + "img/news_info.a6c045fb.jpg";